import ApplicationsAPI from 'remote/applications'
import { actions as UIActions } from 'data/ui'

export function shareToApplication({
  clientId,
  noteId,
  target,
  toasterMessage,
  renderAction = () => {},
}) {
  return ({ getState, dispatch, graphQLClient }) => {
    return {
      type: 'SHARE_NOTE_TO_APPLICATION',
      payload: graphQLClient
        .mutate({
          query: ApplicationsAPI.shareToApplication,
          variables: {
            noteId,
            target,
            clientId,
          },
        })
        .then(
          function onSuccess(response) {
            if (response.errors && response.errors.length) {
              dispatch(
                UIActions.createErrorToasterMessage({
                  title: response.errors[0].message,
                })
              )
            } else {
              let detail = ''

              if (target.privacy === 'personal') {
                detail = `Slitebot will send the doc, it will not appear in your conversation with ${
                  target.label
                }.`
              }
              dispatch(
                UIActions.createSuccessToasterMessage({
                  title: toasterMessage || 'Your doc will be shared promptly',
                  detail,
                  renderAction,
                })
              )
            }
          },
          function onFailure() {
            dispatch(
              UIActions.createErrorToasterMessage({
                title: 'An error occured while sharing your doc.',
                detail:
                  'Please try again or reach out to the support if the problem persists',
              })
            )
          }
        ),
    }
  }
}

export function postInviteLink({ clientId, target }) {
  return ({ getState, dispatch, graphQLClient }) => {
    return {
      type: 'POST_INVITE_TO_SLACK',
      payload: graphQLClient
        .mutate({
          query: ApplicationsAPI.postInviteLink,
          variables: {
            clientId,
            target,
          },
        })
        .then(
          function onSuccess(response) {
            if (response.errors && response.errors.length) {
              dispatch(
                UIActions.createErrorToasterMessage({
                  title: response.errors[0].message,
                })
              )
            } else {
              dispatch(
                UIActions.createSuccessToasterMessage({
                  title: 'Invite posted to Slack',
                })
              )
            }
          },
          function onFailure() {
            dispatch(
              UIActions.createErrorToasterMessage({
                title: 'An error occured while posting the invite',
                detail:
                  'Please try again or reach out to the support if the problem persists',
              })
            )
          }
        ),
    }
  }
}
